function updateURLparam () {
    const url = new URL(window.location.href);
    const search_params = new URLSearchParams(url.search); 

    for(var i of search_params) { // iterate over the query parameters
    // i an an array
    // i[0] => name // i[1] => value
    // console.log(i[0] + ' : ' + i[1]);
    }
    const aft = search_params.toString(); // Put urlParams in to variable

    // Loop to get all anchors 
    document.querySelectorAll('j-go').forEach(function(el) {
        const href = el.getAttribute('href')
        el.setAttribute("href", href + '&' + aft)
    });
}
updateURLparam();